import { useOutletContext, Link } from "react-router-dom";
import { useState, useEffect } from "react";
import {Table} from "reactstrap";

import { translations } from './../../../i18/translations.js';
import AdministrationLinkRow from './assets/AdministrationLinkRow.js';
import { Div } from './../../../util/Html.js';

const AggregateReport = () => {

    const API_URL = process.env.REACT_APP_SERVICE_API_URL;
    const {user, lang, checkAccess} = useOutletContext();

    const [report, setReport] = useState([]);

    const formatNumber = (num) => {
        var result = '';
        if (num && num.length > 0) {
            for (var i = num.length - 1, j = 0; i >= 0; i--, j++) {
                result = (j > 0 && j % 3 === 0 ? '.' : '') + result;
                result = num[i] + result;
            }
        }
        return result;
    };

    useEffect(() => {
        const fetchReport = async () => {
            try {
                const response = await fetch(`${API_URL}/admin/get_administration_report.php`);
                const data = await response.json();
                if (checkAccess(data)) {
                    setReport(data);
                }
            } catch (error) {
                console.error('Error fetching report:', error);
            }
        };
        fetchReport();
    }, [user]);

    return (
            <div className="mbkegy-content">
                <h1 className="mbkegy-content">{translations[lang].aggregate_report}</h1>
            
                <AdministrationLinkRow lang={lang} />
            
                <Table striped className="mbkegy-table">
                    <thead>
                        <tr>
                            <th style={{width: '15%'}}>{translations[lang].year}</th>
                            <th style={{width: '15%'}}>{translations[lang].member_count}</th>
                            <th style={{width: '15%'}}>{translations[lang].paid}</th>
                            <th style={{width: '15%'}}>{translations[lang].unpaid}</th>
                            <th style={{width: '20%'}}>{translations[lang].dues}</th>
                            <th style={{width: '20%'}}>{translations[lang].registered_sum}*</th>
                        </tr>
                    </thead>
                    <tbody>
                        {report && report.map((row) => (
                                <tr key={row.year}>
                                    <td className="text-right">{row.year}</td>
                                    <td className="text-right">{row.members}</td>
                                    <td className="text-right">{row.paid}</td>
                                    <td className="text-right">{row.unpaid}</td>
                                    <td className="text-right">{row.total ? formatNumber(row.total) : '-'} Ft</td>
                                    <td className="text-right">{row.administrated ? formatNumber(row.administrated) : '-'} Ft</td>
                                </tr>
                                        ))}
            
                    </tbody>
                </Table>
            
            
                <div style={{color: "gray", fontSize: "10px", marginTop: "5px"}}>
                    <Div content={translations[lang].report_desc}/>
                </div>
            
            
            </div>
            );
};

export default AggregateReport;